/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An MCP server endpoint documented by a setup guide
 */
export type MCPSetupGuideRemote = {
  /**
   * Stable identifier of the endpoint within the guide
   */
  id: string;
  /**
   * Whether the endpoint URL is customer-specific and has to be filled in per tenant
   */
  tenanted: boolean;
  /**
   * Transport type as published by the guide (e.g., 'streamable-http', 'sse')
   */
  transportType: string;
  /**
   * URL of the endpoint
   */
  url: string;
};

/** @internal */
export const MCPSetupGuideRemote$inboundSchema: z.ZodMiniType<
  MCPSetupGuideRemote,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    tenanted: z.boolean(),
    transport_type: z.string(),
    url: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "transport_type": "transportType",
    });
  }),
);

export function mcpSetupGuideRemoteFromJSON(
  jsonString: string,
): SafeParseResult<MCPSetupGuideRemote, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MCPSetupGuideRemote$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MCPSetupGuideRemote' from JSON`,
  );
}
